import React, { useState } from 'react';

import { useMedia } from 'react-use';

import { ReactComponent as YatLogo } from '../../assets/brand/yat-combo.svg';

import { BackgroundVideo } from './components/BackgroundVideo';
import { Footer } from './components/Footer';
import { MobileMenu } from './components/MobileMenu';
import { Sidebar } from './components/Sidebar';
import { Steps } from './components/Steps';

import { ContentWrapper, Logo, Wrapper } from './StartPage.style';

const videoSources = {
    1: {
        mp4: 'https://y.at/waitlist/vid/20210713/video1.mp4',
        webm: 'https://y.at/waitlist/vid/20210713/video1.webm',
        duration: 14.8,
    },
    2: {
        mp4: 'https://y.at/waitlist/vid/20210713/Video2.mp4',
        webm: 'https://y.at/waitlist/vid/20210713/Video2.webm',
        duration: 6.8,
    },
    3: {
        mp4: 'https://y.at/waitlist/vid/20210713/Video3.mp4',
        webm: 'https://y.at/waitlist/vid/20210713/Video3.webm',
        duration: 6.8,
    },
};

const StartPage = () => {
    const isMobile = useMedia('(max-width: 1000px)');
    const [step, setStep] = useState(1);
    const [open, setOpen] = useState(false);

    return (
        <Wrapper>
            <ContentWrapper>
                <Logo>
                    <YatLogo />
                </Logo>

                {isMobile ? <MobileMenu open={open} setOpen={setOpen} /> : <Footer />}

                <Steps step={step} setStep={setStep} videoSources={videoSources} />

                <Sidebar />
            </ContentWrapper>
            <BackgroundVideo step={step} videoSources={videoSources} />
        </Wrapper>
    );
};

export default StartPage;
